<section class="confirm-email-contain pad-left-40 pad-right-40 pad-top-20 pad-bot-40">
  <div class="close-box heading text-center fnt-18 f600">
    <ng-container i18n>Confirm Email</ng-container>
    <div class="absolute pointer modal-close-svg">
      <svg (click)="hideModal()" width="15" height="15"
          viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
              d="M15 1.51071L13.4893 0L7.5 5.98929L1.51071 0L0 1.51071L5.98929 7.5L0 13.4893L1.51071 15L7.5 9.01071L13.4893 15L15 13.4893L9.01071 7.5L15 1.51071Z"
              fill="#919aa2" />
      </svg>
    </div>
  </div>
  <!-- <div class="fnt-13">Please verify your email ID <b class="fnt-12">john@poshvine.com</b></div> -->
  <section class="form-sec mar-top-22">
    <form [formGroup]="createWithUserForm" (submit)="submitEmailChange()" autocomplete="newpassword">
      <div>
        <label i18n class="mar-bot-5 f600">Your email address</label>
        <div class="input-block">
          <input formControlName="email" class="form-control" type="text" (input)="formSubmited = false" placeholder="abc@xyz.com" />
        </div>
        <div i18n *ngIf="f.email.errors && formSubmited" class="error-txt fnt-12 f500 mar-top-5">
          Please enter a valid email address
        </div>
        <button type = "submit" [disabled] = "f.email.errors" class="btn w100 submit-btn mar-top-20 relative fnt-15">
          <span i18n *ngIf="f.email.value === existingEmail">Send Confirmation Link</span>
          <span i18n *ngIf="f.email.value !== existingEmail">Update Email</span>
          <div class="small-loader btn-load absolute" *ngIf="isLoading"></div>
        </button>
      </div>
    </form>
  </section>
</section>
